import { Checkbox, Menu, MenuItem } from '@mui/material';
import React from 'react';

import Button from '../base/button';
import Text from '../base/text';

interface FilterOption<T> {
  value: T;
  label: string;
}

interface SortMenuProps<T> {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  options: FilterOption<T>[];
  selectedValue: T;
  onSelect: (value: T) => void;
  defaultValue: T;
}

function SortMenu<T>({
  anchorEl,
  open,
  onClose,
  options,
  selectedValue,
  onSelect,
  defaultValue,
}: SortMenuProps<T>) {
  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      {options.map((option) => (
        <MenuItem
          key={String(option.value)}
          onClick={() => {
            onSelect(option.value);
          }}
          dense
        >
          <Checkbox checked={selectedValue === option.value} size="small" />
          <Text>{option.label}</Text>
        </MenuItem>
      ))}
      <MenuItem dense sx={{ borderTop: 1, borderColor: 'divider' }}>
        <Button
          variant="text"
          onClick={() => {
            onSelect(defaultValue);
            onClose();
          }}
        >
          Reset
        </Button>
      </MenuItem>
    </Menu>
  );
}

export default SortMenu;
